import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIWizard from 'UIComponents/dialog/UIWizard';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { ReviewWizardSubmitSection } from './ReviewWizardSubmitSection';
import { ReviewContextProvider, useReviewContext } from './ReviewContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
function ContextualizedReviewWizard({
  children,
  HeaderComponent,
  onClose,
  onSubmit
}) {
  const {
    review
  } = useReviewContext();
  return /*#__PURE__*/_jsx(UIModal, {
    use: "fullscreen",
    children: /*#__PURE__*/_jsx(UIWizard, {
      cancellable: true,
      defaultDoneButton: ReviewWizardSubmitSection,
      defaultDoneLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trellisEcosystem.reviews.submit"
      }),
      headerComponent: HeaderComponent,
      onConfirm: () => onSubmit(review),
      onReject: onClose,
      children: /*#__PURE__*/_jsx(UIWizardStep, {
        children: /*#__PURE__*/_jsx(UIGrid, {
          className: "p-top-4",
          children: /*#__PURE__*/_jsx(UIGridItem, {
            offset: {
              xs: 0,
              md: 1,
              lg: 3
            },
            size: {
              xs: 12,
              md: 10,
              lg: 6
            },
            children: children
          })
        })
      })
    })
  });
}
export function ReviewWizard({
  children,
  customValidationErrors = [],
  defaultReview = {
    content: {},
    ratings: {},
    tags: {}
  },
  HeaderComponent,
  onChange,
  onClose,
  onSubmit,
  validationSchema
}) {
  return /*#__PURE__*/_jsx(ReviewContextProvider, {
    customValidationErrors: customValidationErrors,
    defaultReview: defaultReview,
    onChange: onChange,
    validationSchema: validationSchema,
    children: /*#__PURE__*/_jsx(ContextualizedReviewWizard, {
      HeaderComponent: HeaderComponent,
      onClose: onClose,
      onSubmit: onSubmit,
      children: children
    })
  });
}